import { render, staticRenderFns } from "./PlayerCreation.vue?vue&type=template&id=452065e6&scoped=true&"
import script from "./PlayerCreation.vue?vue&type=script&lang=js&"
export * from "./PlayerCreation.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCreation.vue?vue&type=style&index=0&id=452065e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452065e6",
  null
  
)

export default component.exports